import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useInHub } from '../../../nav/useInHub';

import SubscriptionsDatatable from './Billing/SubscriptionsDatatable';
import PlanDetailsCard from './Billing/PlanDetailsCard';
import UsageDetailCard from './Billing/UsageDetailCard';
import SubscriptionStatusBanner from './Billing/SubscriptionStatusBanner';
import MembershipPlans from './Payment/MembershipPlans';
import AddScreensDialog from './Payment/AddScreensDialog';
import PaymentDialog from './Payment/PaymentDialog';

import { Toast } from 'primereact/toast';

function Billing() {
  const inHub = useInHub();
  const { subscriptionInfo, openDialog, showPaymentPlans } = useSelector((state) => state.global);

  const toast    = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // (The old "subscription expired" toast lived here; the no-package state now covers it.)

  // Handle Stripe Checkout redirect-back query params.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const checkout = params.get('checkout');

    if (checkout === 'success') {
      toast.current?.show({
        severity: 'success',
        summary:  'Payment Successful',
        detail:   'Your subscription has been activated. It may take a moment to reflect.',
        life:     6000,
      });
      // Remove the param without a full reload.
      params.delete('checkout');
      navigate({ search: params.toString() }, { replace: true });
    } else if (checkout === 'cancelled') {
      toast.current?.show({
        severity: 'info',
        summary:  'Checkout Cancelled',
        detail:   'Your payment was not completed.',
        life:     4000,
      });
      params.delete('checkout');
      navigate({ search: params.toString() }, { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card mb-4">
      {showPaymentPlans ? (
        <MembershipPlans />
      ) : (
        <>
          {/* Subscription status banner */}
          <SubscriptionStatusBanner />

          {!inHub && <h3 className="card-header pb-1 bold">Billing</h3>}
          <h5 className="card-header pt-1 w-100 md:w-50">
            Your package, its dates and what it includes. To renew or change your package, contact the PopupPush team.
          </h5>

          <div className="card-body">
            <div className="fs-5 mb-2 underline">Subscription Overview</div>

            <div className="row gx-3 gy-3 px-3 py-3">
              <div className="col-12 col-md-6 d-flex">
                <PlanDetailsCard className="border rounded-4 px-4 py-4 w-100 h-auto h-md-355" />
              </div>
              <div className="col-12 col-md-6 d-flex">
                <UsageDetailCard className="border rounded-4 px-4 py-4 w-100 h-auto h-md-355" />
              </div>
            </div>
          </div>

          <div className="card-body flex flex-col">
            <div className="fs-5 mb-2 underline">Transaction History</div>
            <div className="flex gap-4 px-4 py-3">
              <SubscriptionsDatatable />
            </div>
          </div>
        </>
      )}

      <Toast ref={toast} position="bottom-right" />

      {openDialog.addScreens && <AddScreensDialog />}
      {openDialog.paymentDialog && <PaymentDialog />}
    </div>
  );
}

export default Billing;
